var jade = require("C:\\Users\\kopperts\\Repos\\node_modules\\webpack\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<p></p>" + (null == (jade_interp = require("C:\\Users\\kopperts\\Repos\\node_modules\\webpack\\test\\cases\\loaders\\_resources\\included.jade").call(this, locals)) ? "" : jade_interp));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/_resources/parent.jade
 ** module id = 6
 ** module chunks = 0
 **/